
    import './styles.scoped.css';
    export default {
  "handle": "awsui_handle_cc1pu_y0i9t_1"
};
  